import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '../../../app/store';
import { CompleteCompanyStaffDto, PmSearchResponseDto } from '@inosio/payments-sdk';
interface AssociatedPMsPage {
  Rows: Array<CompleteCompanyStaffDto>;
}
export type AssociatedPMsType = {
  associatedPMsDataPages: Array<AssociatedPMsPage>;
  associatePmsResponse: PmSearchResponseDto;
  isFetchingAssociatePM: boolean;
  isFetchingAssociatePMFailed: boolean;
  isFetchingAssociatePMSuccess: boolean;
  isDelete: boolean;
  isUpdate: boolean;
  isCreate: boolean;
};

const getInitialState = () => {
  return {
    associatedPMsDataPages: [],
    associatePmsResponse: { TotalCount: 0, RecordStart: 0, RangeSize: 100, Rows: [] },
    isFetchingAssociatePM: true,
    isFetchingAssociatePMFailed: false,
    isFetchingAssociatePMSuccess: false,
    isDelete: false,
    isUpdate: false,
    isCreate: false,
  } as AssociatedPMsType;
};

const associatedPMsSlice = createSlice({
  name: 'associatedPMsReducer',
  initialState: getInitialState(),
  reducers: {
    getAssociatedPMs(state, action) {
      state.isFetchingAssociatePM = true;
      state.isCreate = false;
      state.isUpdate = false;
      state.isDelete = false;
    },
    setAssociatedPMs(state, action) {
      /*
 this function has one responsiblity: receive updates from API
 and put the results in state.
 */
      let _payload = action.payload as any;

      //get a copy of the current book
      let currentPmsPages = [...state.associatedPMsDataPages];

      //if startindex = 0, just reset the book because that means it's loading for the first time or he reset the range size
      if (_payload.RecordStart === 0) currentPmsPages = [];

      //find out what page we are on
      let whatPageResultsIsThis = Math.ceil(_payload.RecordStart / _payload.RangeSize);

      //now, add this new data page to our book
      currentPmsPages[whatPageResultsIsThis] = {
        Rows: _payload.Rows,
      };

      //return the full
      let pmsHistoryDetailsData = {
        associatePmsResponse: action.payload,
        associatedPMsDataPages: currentPmsPages,
        isFetchingAssociatePMSuccess: true,
        isFetchingAssociatePMFailed: false,
        isFetchingAssociatePM: false,
      };

      return { ...state, ...pmsHistoryDetailsData };
    },
    getAssociatedPMsFailed(state, action) {
      state.isFetchingAssociatePM = false;
      state.isFetchingAssociatePMFailed = false;
      state.isFetchingAssociatePMSuccess = false;
    },
    createPmStaff(state, action) {},
    setCreatePMStatus(state, action) {
      state.isCreate = true;
    },
    updatePmStaff(state, action) {},
    setUpdatePMStatus(state, action) {
      state.isUpdate = true;
    },
    deletePmStaff(state, action) {},
    setDeletePMStatus(state, action) {
      state.isDelete = true;
    },
  },
});

export const { getAssociatedPMs, setAssociatedPMs, getAssociatedPMsFailed, createPmStaff, setCreatePMStatus, updatePmStaff, setUpdatePMStatus, deletePmStaff, setDeletePMStatus } = associatedPMsSlice.actions;
export default associatedPMsSlice.reducer;
export const selectAssociatedPMsDataPages = (state: RootState) => state.pmAMModuleState.associatedPMsDataPages;
export const selectAssociatedPMsResponse = (state: RootState) => state.pmAMModuleState.associatePmsResponse;
export const selectDeleteState = (state: RootState) => state.pmAMModuleState.isDelete;
export const selectUpdateState = (state: RootState) => state.pmAMModuleState.isUpdate;
export const selectCreateState = (state: RootState) => state.pmAMModuleState.isCreate;
export const selectAssociatedPMState = (state: RootState) => state.pmAMModuleState;
